export class DataBase {
  static blank() {
    return new this({});
  }

  constructor(json) {
    Object.assign(this, json);
  }

  static fromServer(json) {
    return new DataBase({
      port: json.port,
      version: json.dbaVersion,
      frameWork: json.dbaFrame,
      userName: json.dbaName,
      dataBasePwd: json.dbaPwd,
    });
  }

  dataBaseId = "";
  name = "";
  port = "";
  version = "";
  frameWork = "";
  userName = "";
  dataBasePwd = "";
  hashPwd = "******";
  showPwd = false;
}
